import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'header-menu',
    templateUrl: 'header-menu.component.html'
})

export class HeaderMenuComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/header/header-menu.component.ts